import { render, staticRenderFns } from "./GridLayout.vue?vue&type=template&id=27b36423&"
import script from "./GridLayout.vue?vue&type=script&lang=js&"
export * from "./GridLayout.vue?vue&type=script&lang=js&"
import style0 from "./GridLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports